import { useEffect, useState, useContext,useRef } from "react";
import axios from "axios";
import MyContext from "../../MyContext";
import Swal from "sweetalert2";
import notificationSound from "../../Sound/3beeps-108353.mp3"; 
import muteIcon from "../../images/enable-sound.png"; 
const OrderWebSocket = ({ userID, onNewOrder }) => {
    const audioRef = useRef(null);
  const [currentCatalogueStatus, setCurrentCatalogueStatus] = useState("");
  const [showSoundReminder, setShowSoundReminder] = useState(false);
  const reminderTimeoutRef = useRef(null);
  const { baseUrl, config } = useContext(MyContext);
  const [processedOrders, setProcessedOrders] = useState(() => {
    const savedOrders = localStorage.getItem("processedOrders");
    return savedOrders ? JSON.parse(savedOrders) : [];
  });

  
 // Initialize audio once
   useEffect(() => {
    const audio = new Audio(notificationSound);
    audio.preload = "auto";
    audio.loop = true;
    audio.volume = 1.0;
    audioRef.current = audio;

    // Unlock audio on first user interaction
    const unlockAudio = () => {
      audio.muted = true;
      audio
        .play()
        .then(() => {
          audio.pause();
          audio.muted = false;
          localStorage.setItem("soundUnlocked", "true");
          console.log("🔓 Audio unlocked");
        })
        .catch((err) => {
          console.warn("Unlock failed:", err);
        });

      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("mousemove", unlockAudio);
    };

    if (localStorage.getItem("soundUnlocked") !== "true") {
      document.addEventListener("click", unlockAudio, { once: true });
      document.addEventListener("mousemove", unlockAudio, { once: true });
    }

    return () => {
      document.removeEventListener("click", unlockAudio);
      document.removeEventListener("mousemove", unlockAudio);
    };
  }, []);

 

  const getNewOrder = async () => {
    try {
      const requestBody = {
        userid: userID,
        secret: "string",
        fromdate: new Date().toISOString().split("T")[0],
        todate: new Date().toISOString().split("T")[0],
        status: ["received"],
      };

      const response = await axios.post(
        `${baseUrl}/api/Whatsapp/getCatalogOrders`,
        requestBody,
        config
      );

      if (response.data.responseCode === "00") {
        const fetchedOrders = response.data.response;
        const newOrders = fetchedOrders.filter(
          (order) => !processedOrders.includes(order.orderid)
        );

        if (newOrders.length > 0) {
          console.log("🎉 New Orders Found!", newOrders);
          

          // Swal.fire({
          //   title: "New Order Received!",
          //   text: `Order ID: ${newOrders[0].daily_order_id} has arrived.`,
          //   icon: "info",
          //   confirmButtonText: "Okay",
          // });

          const updatedProcessedOrders = [
            ...processedOrders,
            ...newOrders.map((order) => order.orderid),
          ];
          setProcessedOrders(updatedProcessedOrders);
          localStorage.setItem(
            "processedOrders",
            JSON.stringify(updatedProcessedOrders)
          );
        }
      } else {
        console.error(" Failed to fetch orders:", response.data.responseMessage);
      }
    } catch (error) {
      console.error(" Error fetching data:", error);
    }
  };


    const catalogueStatusApi = async () => {
      try {
      
        const requestBody = {
          userid: userID,
        };
        const response = await axios.post(
          `${baseUrl}/api/Whatsapp/getCatalogueStatus`,
          requestBody,
          config
        );
  
        if (response.data.responseCode === "00") {
          setCurrentCatalogueStatus(response.data.response.catalogueStatus);
        } else {
        }
      } catch {}
    };

  useEffect(() => {
    if (!userID) {
      console.error("userID is missing. WebSocket connection not started.");
      return;
    }
  
    let uniqueId = sessionStorage.getItem('uniqueId');
    if (!uniqueId) {
      uniqueId = crypto.randomUUID();
      sessionStorage.setItem('uniqueId', uniqueId);
    }
  
    let socket;
    let interval;
  

    
    const connectWebSocket = () => {
      console.log("🔌 Connecting to WebSocket with userID:", userID);

      socket = new WebSocket(`wss://payinnew.remittpe.com/ws?userId=${uniqueId}&roomId=${userID}_order_room_v1`);
  
      socket.onopen = () => {
        console.log("✅ WebSocket Connected");
      };
  
      socket.onmessage = (event) => {
        console.log("📩 WebSocket Message Received:", event.data);
  
        try {
          const orderData = JSON.parse(event.data);
          console.log("📦 Parsed Order Data:", orderData);
  
          if (orderData.Message === "New Order Received") {
            Swal.fire({
              title: "New Order Received!",
              icon: "info",
              confirmButtonText: "Okay",
            }).then(() => {
              if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
              }
            });
  
            if (audioRef.current) {
              audioRef.current
                .play()
                .then(() => console.log("🔊 Notification played"))
                .catch((err) => console.warn("Sound play failed:", err));
            }
  
            console.log("🔔 New order detected! Calling API...");
            onNewOrder();
            getNewOrder();
          }
        } catch (error) {
          console.error("❌ Error parsing WebSocket message:", error, "Data:", event.data);
        }
      };
  
      socket.onerror = (error) => {
        console.error("⚠️ WebSocket Error:", error);
      };
  
      socket.onclose = (event) => {
        console.warn("🔴 WebSocket Closed:", event.reason, "Code:", event.code);
      };
    };
  
    // Connect initially
    connectWebSocket();
  
    // Reconnect every 5 minutes
    interval = setInterval(() => {
      console.log("♻️ Reconnecting WebSocket every 5 minutes...");
      connectWebSocket();
    }, 1 * 60 * 1000); // 5 minutes
  
    return () => {
      clearInterval(interval);
      if (socket) socket.close();
    };
  }, [userID]);

  useEffect(() => {
    if (!userID) return;
    catalogueStatusApi();
    // Check and re-verify if audio is actually unlocked
    const checkReminder = async () => {
      const audio = audioRef.current;
      if (!audio) return;
      try {
        await audio.play();
        audio.pause();
        localStorage.setItem("soundUnlocked", "true");
        console.log("🔓 Audio verified as unlocked");
      } catch (err) {
        console.warn("🔒 Audio still locked, will show reminder if needed");
        localStorage.removeItem("soundUnlocked");
  
        if (currentCatalogueStatus === "show") {
          reminderTimeoutRef.current = setTimeout(() => {
            setShowSoundReminder(true);
          }, 500);
        }
      }
    };
    checkReminder();
    return () => {
      clearTimeout(reminderTimeoutRef.current);
    };
  }, [currentCatalogueStatus, userID]);
  // return null;
  return(
    <>
{showSoundReminder && (
  <div
    onClick={() => {
      setShowSoundReminder(false);
      const unlockAudio = () => {
        if (audioRef.current) {
          audioRef.current.muted = true;
          audioRef.current
            .play()
            .then(() => {
              audioRef.current.pause();
              audioRef.current.muted = false;
              localStorage.setItem("soundUnlocked", "true");
            })
            .catch((err) => console.warn("Manual unlock failed:", err));
        }
      };
      unlockAudio();
    }}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.6)",
      backdropFilter: "blur(4px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      cursor: "pointer",
    }}
  >
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        padding: "30px 40px",
        maxWidth: "700px",
        boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        textAlign: "center",
        animation: "fadeInUp 0.6s ease-out",
      }}
    >
     <div style={{ textAlign: "center", maxWidth: "700px", padding: "20px" }}>
  <div style={{ fontSize: "3rem", marginBottom: "10px" }}>
    <img src={muteIcon} height={100} alt="" />
  </div>

  <h2 style={{ fontSize: "2.5rem", marginBottom: "10px", color: "#222" }}>
    Sound Alerts : OFF
  </h2>

  <p style={{ fontSize: "1.5rem", color: "#555", marginBottom: "10px" }}>
    Click anywhere on the screen to enable sound notifications.
  </p>

</div>
</div>
    <style>{`
      @keyframes fadeInUp {
        from {
          transform: translateY(30px);
          opacity: 0;
        }
        to {
          transform: translateY(0);
          opacity: 1;
        }
      }
    `}</style>
  </div>
)}
    </>
  )
};

export default OrderWebSocket;
